<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="dedit">To my mother,</p>
<p class="dedi">Janice Norma Peace,</p>
<p class="dedi">who initiated my love of history</p>
<p class="dedi">and rescued it in 1985.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedi.vue?f3d17d1a